export function groupBy(items, callback) {
  return items.reduce((groups, item) => {
    const key = callback(item);
    groups[key] ||= [];
    groups[key].push(item);
    return groups;
  }, {});
}

export function number(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function pct(correct, total) {
  const totalNumber = number(total);
  if (!totalNumber) return 0;
  return Math.round((number(correct) / totalNumber) * 100);
}
